<p class="title">
    <img class="icon-title" src="assets/images/edit.svg" alt="Image" />
    {{'grupo-edit.texts.editar_grupo' | translate}}
</p>
<div class="container">
    <div id="mainDiv" class="main-div form-div">
        <div id="mainDiv" class="form-container">
            <div class="form-column">
                <div class="form-item form-item-25">
                    <label class="pb-2">{{'grupo-edit.labels.nome' | translate}}</label>
                    <input type="text" pInputText placeholder="{{'grupo-edit.placeholders.nome_do_grupo' | translate}}"
                        [(ngModel)]="form.nome" />
                </div>
                <div class="form-item form-item-25">
                    <label class="pb-2">{{'grupo-edit.labels.status' | translate}}</label>
                    <p-selectButton [options]="stateOptions" [(ngModel)]="form.status" optionLabel="label"
                        optionValue="value" />
                </div>
            </div>

            <div class="form-column">
                <div class="form-item form-item-100">
                    <button pButton label="{{'grupo-edit.botoes.salvar' | translate}}" class="w-8rem"
                        (click)="submit()"></button>
                </div>
            </div>
        </div>


    </div>
</div>